<template>
  <div class="container-fluid row">
    <div class="mt-5">
      <div class="card-body">
        <div class="row">
          <div class="col-md-12 mt-3">
            <h5 class="card-title">ต้นแบบการนำเข้าข้อมูลการคุมสอบ</h5>
          </div>
          <div class="col-md-12">
            <button class="btn btn-sm btn-info">
              <div><a :href="prototype" style="color:white;text-decoration: none;"> ดาวน์โหลดต้นแบบ</a></div>
            </button>

          </div>
          <div class="col-md-3 mt-5">
            <label for="exampleInputEmail1" class="form-label">เลือกไฟล์สำหรับบันทึกข้อมูลลงระบบ</label>
            <input type="file" @change="onChangeC1" class="form-control-file" id="exampleFormControlFile1" />
            <button @click="save()" type="button" class="btn btn-success btn-sm mt-3">
              บันทึกข้อมูลลงในระบบ
            </button>
          </div>
        </div>
      </div>
    </div>
    <hr>
      <div class="card-body">
        <div class="row">
          <div class="col-md-12">
            <h5 class="card-title">ค้นหาข้อมูล</h5>
          </div>
          <div class="col-md-3 mt-3">
            <label for="exampleFormControlSelect1">ปีการศึกษา</label>
            <select v-model="filter.year" class="form-select form-control-sm" id="exampleFormControlSelect1">
              <option v-for="(s, i) in year" v-bind:value="s.id" :key="i + 1">
                {{ s.name }}
              </option>
            </select>
          </div>
          <div class="col-md-3 mt-3">
            <label for="exampleFormControlSelect1">เทอม</label>
            <select v-model="filter.term" class="form-select form-control-sm" id="exampleFormControlSelect1">
              <option v-for="(s, i) in term" v-bind:value="s.id" :key="i + 1">
                {{ s.name }}
              </option>
            </select>
          </div>
          <div class="col-md-3 mt-3 mb-3">
            <label for="exampleFormControlSelect1">ประเภทการสอบ</label>
            <select v-model="filter.exam_type" class="form-select form-control-sm" id="exampleFormControlSelect1">
              <option v-for="(s, i) in exam_type" v-bind:value="s.name" :key="i + 1">
                {{ s.nameTH }}
              </option>
            </select>
          </div>
          <div class="col-md-3 mt-3 mb-3">
            <label for="exampleFormControlSelect1">เลือกวันที่สอบ</label>
            <input type="date" id="examDate" class="form-control form-control-sm" v-model="filter.exam_date"
              @change="formatDateFilter" />
          </div>
          <div class="col-md-3 mt-3 mb-3">
            <label for="exampleFormControlSelect1">รายวิชา</label>
            <input type="text" id="examDate" class="form-control form-control-sm" v-model="filter.subject" />
          </div>
          <div class="col-md-3 mt-3 mb-3">
            <label for="exampleFormControlSelect1">อาจารย์ผู้สอน</label>
            <input type="text" id="examDate" class="form-control form-control-sm" v-model="filter.instructor" />
          </div>
          <div class="col-md-3 mt-3 mb-3">
            <label for="exampleFormControlSelect1">คณะ</label>
            <select v-model="filter.faculty_id" class="form-select form-control-sm" id="exampleFormControlSelect1"
              @change="getCoursesByFaculty">
              <option v-for="(s, i) in faculty" v-bind:value="s.id" :key="i + 1">
                {{ s.nameTH }}
              </option>
            </select>
          </div>
          <div class="col-md-3 mt-3 mb-3">
            <label for="exampleFormControlSelect1">หลักสูตร</label>
            <select v-model="filter.course_id" class="form-select form-control-sm" id="exampleFormControlSelect1"
              @change="getFacultyByCourses">
              <option v-for="(s, i) in courselist" v-bind:value="s.id" :key="i + 1">
                {{ s.nameTH }}
              </option>
            </select>
          </div>

          <div class="col-md-3">
            <button @click="search()" type="button" class="btn btn-success btn-sm">
              ค้นหา
            </button>&nbsp;
            <button @click="clear()" type="button" class="btn btn-danger btn-sm">
              ล้างค่าการค้นหา
            </button>
          </div>
        </div>
      </div>
      <clip-loader :loading="loading" :color="color" :size="size"></clip-loader>
    <div class="col-md-12 mt-5" style="margin: 5px" v-if="subjectdisplay.length > 0">
      <div v-for="(group, index) in subjectdisplay" :key="index" class="mb-4 border rounded">
        <div class="p-2 bg-secondary text-white d-flex justify-content-between align-items-center"
          style="cursor: pointer;" @click="toggleGroup(index)">
          <strong>ปี {{ group.term }}/{{ group.year }}
            ({{ group.exam_type === 'M' ? 'Midterm' : group.exam_type === 'F' ? 'Final' : '' }})
          </strong>
          <span @click="toggleGroup(index)">{{ group.show ? '▲ ซ่อน' : '▼ แสดง' }}</span>
        </div>

        <!-- <div class="collapse" id="collapseExample"> -->
        <div class="table-responsive" v-show="group.show">
          <table class="table table-bordered mt-2">
            <thead>
              <tr style="text-align: center">
                <th scope="col" style="background-color: #C4996C">ลำดับที่</th>
                <th scope="col" style="background-color: #C4996C">
                  ปีการศึกษา
                </th>
                <th scope="col" style="background-color: #C4996C">
                  เทอม
                </th>
                <th scope="col" style="background-color: #C4996C">
                  รหัสรายวิชา
                </th>
                <th scope="col" style="background-color: #C4996C">ชื่อรายวิชา</th>
                <th scope="col" style="background-color: #C4996C">หน่วยกิต</th>
                <th scope="col" style="background-color: #C4996C">หมู่เรียน</th>
                <th scope="col" style="background-color: #C4996C">กลุ่ม</th>
                <th scope="col" style="background-color: #C4996C">อาจารย์ผู้สอน</th>
                <th scope="col" style="background-color: #C4996C">ตำแหน่งทางวิชาการ</th>
                <th scope="col" style="background-color: #C4996C">ผู้รับผิดชอบรายวิชา</th>
                <th scope="col" style="background-color: #C4996C">เพศ</th>
                <th scope="col" style="background-color: #C4996C">EXAM_DATE</th>
                <th scope="col" style="background-color: #C4996C">EXAM_TIME_FROM</th>
                <th scope="col" style="background-color: #C4996C">EXAM_TIME_TO</th>
                <th scope="col" style="background-color: #C4996C">EXAM_TYPE</th>
                <th scope="col" style="background-color: #C4996C">คณะ</th>
                <th scope="col" style="background-color: #C4996C">หลักสูตร</th>
                <th scope="col" style="background-color: #C4996C">จำนวนนิสิต</th>
                <th scope="col" style="background-color: #C4996C">ห้องสอบ</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(s, i) in group.list_data" :key="s.id">
                <th scope="row" style="text-align: center">{{ i + 1 }}</th>
                <th scope="row" style="text-align: center">{{ s.year }}</th>
                <th scope="row" style="text-align: center">{{ s.term }}</th>
                <th scope="row" style="text-align: center">{{ s.code }}</th>
                <th scope="row" style="text-align: center">{{ s.major_name }}</th>
                <th scope="row" style="text-align: center">{{ s.credit }}</th>
                <th scope="row" style="text-align: center">{{ s.section }}</th>
                <th scope="row" style="text-align: center">{{ s.group }}</th>
                <th scope="row" style="text-align: center">{{ s.prefix }} {{ s.firstname }} {{ s.lastname }}</th>
                <th scope="row" style="text-align: center">{{ s.academic_positions }}</th>
                <th scope="row" style="text-align: center">ใช่</th>
                <th scope="row" style="text-align: center">{{ s.sex }}</th>
                <th scope="row" style="text-align: center">{{ formatDate(s.exam_date) }}</th>
                <th scope="row" style="text-align: center">{{ parseFullTimeToMinutes(s.exam_time_from) }}</th>
                <th scope="row" style="text-align: center">{{ parseFullTimeToMinutes(s.exam_time_to) }}</th>
                <th scope="row" style="text-align: center">{{ s.exam_type }}</th>
                <th scope="row" style="text-align: center">{{ s.faculty_name }}</th>
                <th scope="row" style="text-align: center">{{ s.course_name }}</th>
                <th scope="row" style="text-align: center">{{ s.number }}</th>
                <th scope="row" style="text-align: center">{{ s.room }}</th>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import readXlsxFile from "read-excel-file";
// import axios from 'axios';
import LinkService from "../services/LinkService";
import CourseService from "../services/CourseService";
import ProctorService from "../services/ProctorService";
import MajorService from "../services/MajorService";
import SubjectService from "../services/SubjectService";
import AcademicPositionService from "../services/AcademicPositionService";
import FacultyService from "../services/FacultyService";
import ClipLoader from 'vue-spinner/src/ClipLoader.vue'

export default {
  name: "Nav",
  props: {
    msg: String,
  },
  components: {
    ClipLoader
  },
  data() {
    return {
      prototype: '',
      faculty: [],
      course: [],
      courselist: [],
      proctor: [],
      major: [],
      subjects: [],
      academic_positions: [],
      year: [],
      term: [],
      exam_type: [],
      filter: { year: '', term: '', exam_type: '', exam_date: '', faculty_id: '', course_id: '', subject: '', instructor: '' },
      subjectdisplay: [],
      loading:false,
    };
  },
  mounted() {
    this.prototype = LinkService.getLink() + '/uploads/exam_proctor.xlsx';
    this.getFaculty()
    this.getCourses()
    this.getProctor();
    this.getMajors();
    this.getAcademicPosition()
    this.getSubjectsDisplay();
this.getlistyear()
  },
  methods: {
    getlistyear(){
      const currentYear = new Date().getFullYear() + 543;
const startYear = 2567;

this.year = Array.from({ length: currentYear - startYear + 1 }, (_, i) => {
  const year = startYear + i;
  return { id: year, name: year };
});

console.log(this.year);
    },
    toggleGroup(index) {
      const group = this.subjectdisplay[index];
      if (group.show === undefined) {
        this.$set(group, 'show', true);  // หรือ false ถ้าต้องการค่าเริ่มต้น
      } else {
        group.show = !group.show;
      }
    },
    clear() {
      this.filter = { year: '', term: '', exam_type: '', exam_date: '', faculty_id: '', course_id: '', subject: '', instructor: '' }
      this.getCourses()
      this.getSubjectsDisplay()
    },
    getFacultyByCourses() {
      const facultylist = this.course.find(c =>
        c.id === this.filter.course_id
      );
      this.filter.faculty_id = facultylist.faculty_id;
    },
    getCoursesByFaculty() {
      const courselist = this.course.filter(c =>
        c.faculty_id === this.filter.faculty_id
      );
      this.courselist = courselist;
    },
    formatDateFilter() {
      if (!this.examDate) return;
      const date = new Date(this.examDate);
      const year = date.getFullYear();
      const month = (`0${date.getMonth() + 1}`).slice(-2); // เติม 0
      const day = (`0${date.getDate()}`).slice(-2);
      this.filter.exam_date = `${year}-${month}-${day}`;
    },
    search() {
      this.getSubjectsDisplay()
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // เดือนเริ่มจาก 0
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    parseFullTimeToMinutes(timeStr) {
      if (typeof timeStr !== 'string') return "ไม่พบเวลา";

      const parts = timeStr.split(':');
      if (parts.length < 2 || parts.length > 3) return "ไม่พบเวลา";

      const hours = parseInt(parts[0], 10);
      const minutes = parseInt(parts[1], 10);

      if (
        isNaN(hours) || isNaN(minutes) ||
        hours < 0 || hours > 23 ||
        minutes < 0 || minutes > 59
      ) {
        return "ไม่พบเวลา";
      }

      return hours * 60 + minutes;
    },
    getFaculty() {
      FacultyService.getFacultys().then((res) => {
        this.faculty = res.data;
        // console.log(this.faculty);
      });
    },
    getCourses() {
      CourseService.getCourses().then((res) => {
        this.course = res.data;
        this.courselist = res.data
        // console.log(this.course);
      });
    },
    getMajors() {
      MajorService.getMajors().then((res) => {
        this.major = res.data;
        // console.log(this.major);
      });
    },
    getProctor() {
      ProctorService.getProctors().then((res) => {
        this.proctor = res.data;
        // console.log(this.proctor);
      });
    },
    getAcademicPosition() {
      AcademicPositionService.getAcademicPosition().then((res) => {
        this.academic_positions = res.data;
        // console.log(this.academic_positions);
      });
    },
    getSubjectsDisplay() {
      SubjectService.getSubjectsDisplay(this.filter).then((res) => {
        this.subjectdisplay = res.data;
        this.subjectdisplay.forEach(group => {
          this.$set(group, 'show', false); // ใช้ Vue.set หรือ this.$set
        });
        this.year = [...new Set(this.subjectdisplay.map(item => item.year))] // unique years
  .sort((a, b) => b - a) // sort descending if needed
  .map(y => ({ id: y, name: y }));
  this.term = [...new Set(this.subjectdisplay.map(item => item.term))] // unique years
  .sort((a, b) => b - a) // sort descending if needed
  .map(y => ({ id: y, name: y }));

  const examTypeMap = {
  M: { id: 1, nameTH: "Midterm", name: "M" },
  F: { id: 2, nameTH: "Final", name: "F" }
}
  this.exam_type = [...new Set(this.subjectdisplay.map(item => item.exam_type))]
  .map(code => examTypeMap[code])
  .filter(Boolean) // กัน null กรณีเจอ code แปลกๆ
console.log(this.year);
console.log(this.term);
console.log(this.exam_type);
        console.log(this.subjectdisplay);
      });
    },
    async getSubjects() {
      const res = await SubjectService.getSubjects();
      this.subjects = res.data;
    },
    converttime(value) {
      // ถ้าไม่ตรงใน map แปลงเป็น HH:mm
      if (typeof value === "number" && value >= 0 && value < 1440) {
        const hours = Math.floor(value / 60);
        const minutes = value % 60;
        return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
      }

      return "ไม่พบเวลา";
    },
    async createProctor(file) {
      const res = await ProctorService.createProctor({
        prefix: file.prefix,
        firstname: file.firstname,
        lastname: file.lastname,
        academic_positions: file.academic_position_id,
        faculty_id: file.faculty_id,
        course_id: file.course_id,
        sex: file.sex,
        health: 1,
        status: 1
      });
      return res.data.id;

    },
    async createMajor(faculty_id, file) {
      const res = await MajorService.createMajor({
        faculty_id: faculty_id,
        code: file.code,
        nameTH: file.nameTH,
        status: 1,
      });
      return res.data.id;
    },
    async createSubject(subject) {
      const res = await SubjectService.createSubject(subject);
      return res.data.id;
    },
    async getmaxS(year, term, examType, proctor_list) {
      console.log(year, term, examType);

      // รอข้อมูล subjects
      await this.getSubjects();
      // console.log('📚 subjects:', this.subjects);

      // filter เฉพาะที่ตรงกับ year, term, examType
      const subject_list = this.subjects.filter(s =>
        s.year === year && s.term === term && s.exam_type === examType
      );
      // console.log('🎯 subject_list:', subject_list);

      // สร้าง Set เพื่อนับจำนวน unique major/instructor
      const majorSet = new Set(subject_list.map(s => s.major_id));
      const instructorSet = new Set(subject_list.map(s => s.instructor_id));

      const Ni = majorSet.size;
      const CN = instructorSet.size;
      const maxS = CN > 0 ? Math.ceil((2 * Ni) / CN) : 0;

      console.log(`✅ Ni: ${Ni}, CN: ${CN}, maxS: ${maxS}`);
      await this.updatemaxS(maxS, proctor_list);
      return maxS
    },
    async updatemaxS(maxS, list) {
      for (const proctor of list) {
        if (!proctor.maxS) {
          await ProctorService.updateProctor(proctor, { "maxS": maxS });
        }
      }
    },
    async save() {
      if (this.file == "") {
        alert("กรุณาเลือกไฟล์ข้อมูลการคุมสอบก่อนนำเข้าข้อมูล");
      } else if (this.file.length > 0) {
        this.loading =true
        var exist = []
        var proctor_list = []
        for (let i = 1; i < this.file.length; i++) {
          console.log(this.file[i]);
          const input = new Date(this.file[i][11]);
          const date = input.toISOString().split('T')[0];
          const firstname = this.file[i][7]

          var sex = this.file[i][10]
          var year = this.file[i][0]
          var term = this.file[i][1]
          var credit = this.file[i][4]
          var section = this.file[i][5]
          var number = this.file[i][18]
          var room = this.file[i][17]
          var group = this.file[i][6]
          var code = this.file[i][2]
          var nameTH = this.file[i][3]
          var exam_type = this.file[i][14]
          var academicposition = this.file[i][8]
          var exam_date = date
          var exam_time_from = this.converttime(this.file[i][12])
          var exam_time_to = this.converttime(this.file[i][13])

          let instructor_id = '';
          var major_id = '';

          var course = this.course.find(c => c.nameTH === this.file[i][16]);
          var faculty_id = course.faculty_id;
          var course_id = course.id;

          var academic_position = this.academic_positions.find(c => c.name === academicposition);
          var academic_position_id = academic_position.id


          var proctor = this.proctor.find(c => c.firstname === firstname && c.faculty_id === faculty_id && c.course_id === course_id);
          if (!proctor) {
            instructor_id = await this.createProctor({
              firstname: firstname,
              academic_position_id: academic_position_id,
              faculty_id: faculty_id,
              course_id: course_id,
              sex: sex,
            })
            // console.log('instructor_id', instructor_id);
          } else {
            instructor_id = proctor.id;
          }
          proctor_list.push(instructor_id)
          var major = this.major.find(c => c.code === code && c.nameTH === nameTH);
          // console.log(major);

          if (!major) {
            major_id = await this.createMajor(faculty_id, { code: code, nameTH: nameTH });
            // console.log('major_idd', major_id);
          } else {
            major_id = major.id;
          }
          // console.log('instructor_id', instructor_id);
          // console.log('major_id', major_id);

          // console.log('input', input);
          // console.log('date', date);

          await this.getSubjects()
          // console.log(this.subjects);


          var status = this.subjects.find(c => c.instructor_id === instructor_id && c.year === year && c.term === term && c.major_id === major_id && c.exam_type === exam_type && c.section === section && c.group === group && c.number === number);


          if (!status) {
            var subject = {
              //   faculty_id: faculty_id,
              // course_id: course_id,
              major_id: major_id,
              instructor_id: instructor_id,
              instructor_status: 1,
              year: year,
              term: term,
              credit: credit,
              section: section,
              number: number,
              exam_type: exam_type,
              exam_date: exam_date,
              exam_time_from: exam_time_from,
              exam_time_to: exam_time_to,
              room: room,
              group: group,
              status: 1,
            }
            var subject_id = await this.createSubject(subject)
            console.log('subject_id', subject_id);
            await this.getCourses()
            await this.getProctor();
            await this.getMajors();
            await this.getAcademicPosition()
            await this.getSubjects()
            if (i === this.file.length - 1) {
              var maxS = await this.getmaxS(year, term, exam_type, proctor_list);
              console.log(maxS);

            }

          } else {
            exist.push({
              faculty_id: faculty_id,
              course_id: course_id,
              major_id: major_id,
              instructor_id: instructor_id,
              year: year,
              term: term,
              section: section,
            });
          }
          await this.getCourses()
          await this.getProctor();
          await this.getMajors();
          await this.getAcademicPosition()
          await this.getSubjects()
          if (i === this.file.length - 1) {
            this.loading =false
            // var maxS = await this.getmaxS(this.file[i][0],this.file[i][1],this.file[i][13]);
            // console.log(maxS);
            // await this.updatemaxS(maxS, proctor_list);
            if (exist.length > 0) {
              if (exist.length == this.file.length - 1) {
                alert(`ข้อมูลที่ซ้ำกัน ${exist.length} รายการ`);
              } else {
                alert(`นำเข้าข้อมูลสำเร็จ มีข้อมูลที่ซ้ำกัน ${exist.length} รายการ`);
              }
              console.log(exist);
            } else {
              alert("นำเข้าข้อมูลการคุมสอบสำเร็จ");
            }
            this.getSubjectsDisplay();
            this.file = ''
          }
        }

      }
    },
    onChangeC1(event) {
      readXlsxFile(event.target.files[0]).then((data) => {
        this.file = data;

      });
    },
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
    currentUser() {
      return this.$store.state.auth.user;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.vertical-menu {
  background-color: #eee;
}

.vertical-menu a {
  background-color: #eee;
  color: black;
  display: block;
  padding: 12px;
  text-decoration: none;
}

.vertical-menu a:hover {
  background-color: #ccc;
}

.vertical-menu a.active {
  background-color: #04aa6d;
  color: white;
}

.card {
  margin: 0 auto;
  /* Added */
  float: none;
  /* Added */
  margin-bottom: 10px;
  /* Added */
}

body {
  background-color: gray;
}

hr {
  border: none;
  border-top: 1px solid #ccc;
  margin: 20px 0;
}

.row {
  margin-left: 0px;
  margin-right: 0px;
}
</style>
